import { useEffect } from 'react';
import { CurrentShipperUser } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useCurrentShipperUser() {
  const shipper = useAxios(
    (axios, signal) =>
      axios.request<CurrentShipperUser>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shipperUsers`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipper.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shipper;
}

export type CurrentShipperUserRequest = ReturnType<
  typeof useCurrentShipperUser
>;
